/*global diy*/
var domainpromo = require('diy/domainpromo/domainpromo');
var l10n = require('diy/util/l10n');
var NotificationBase = require('diy/toolbar/notification/NotificationBase');

var NoDomainNotification;

NoDomainNotification = NotificationBase.extend({
    /**
     * Default sticky for NoDomainNotification
     */
    stickyDefault: 1,
    /**
     * Default severity for NoDomainNotification
     */
    severityDefault: 1,
    /**
     * Default category for NoDomainNotification
     */
    categoryDefault: 1,
    /**
     * parameters for determining default operation,
     * if null or false, they are ignored
     */
    iconCls: 'ui-icon-alert',
    /**
     * this method must be implemented by all Notifications
     */
    getContent: function() {
        return '<span>' + l10n.getString('domainConnection.notification.infoText') + '</span>';
    },

    globalAction: function() {
        domainpromo.show();
    },

    getName: function() {
        return 'NoDomainNotification';
    }
});

module.exports = NoDomainNotification;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/Notifications/NoDomainNotification.js
 ** module id = 648
 ** module chunks = 0
 **/